import React from 'react';
import clsx from 'clsx';
import { IconButton, Tooltip } from '@material-ui/core';
import {
  FaTable,
  FaBorderNone,
  FaBorderAll,
  FaStream,
  FaPlus,
  FaMinus,
  FaTrashAlt,
} from 'react-icons/fa';

const BarraContextualTabla = ({
  classes,
  estiloTablaActual,
  onCambiarEstiloTabla,
  onInsertarFila,
  onEliminarFila,
  onInsertarColumna,
  onEliminarColumna,
  onEliminarTabla,
}) => {
  return (
    <div className={classes.tableContextGroup}>
      <span className={classes.tableContextLabel}>
        <FaTable size={11} /> Tabla:
      </span>
      <Tooltip title={estiloTablaActual === 'sin-bordes' ? 'Tabla sin bordes (activa)' : 'Quitar bordes / Sin bordes'}>
        <IconButton
          size="small"
          className={clsx(classes.iconButton, estiloTablaActual === 'sin-bordes' && classes.iconButtonActive)}
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => onCambiarEstiloTabla('sin-bordes')}
        >
          <FaBorderNone size={12} />
        </IconButton>
      </Tooltip>
      <Tooltip title={estiloTablaActual === 'con-bordes' ? 'Cuadrícula con bordes (activa)' : 'Bordes completos (Cuadrícula)'}>
        <IconButton
          size="small"
          className={clsx(classes.iconButton, estiloTablaActual === 'con-bordes' && classes.iconButtonActive)}
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => onCambiarEstiloTabla('con-bordes')}
        >
          <FaBorderAll size={12} />
        </IconButton>
      </Tooltip>
      <Tooltip title={estiloTablaActual === 'horizontales' ? 'Líneas horizontales (activa)' : 'Solo líneas horizontales'}>
        <IconButton
          size="small"
          className={clsx(classes.iconButton, estiloTablaActual === 'horizontales' && classes.iconButtonActive)}
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => onCambiarEstiloTabla('horizontales')}
        >
          <FaStream size={12} />
        </IconButton>
      </Tooltip>

      {/* Separador vertical */}
      <span style={{ height: 16, borderRight: '1px solid #cbd5e1', margin: '0 4px' }} />

      {/* Acciones de Filas */}
      <Tooltip title="Insertar fila abajo">
        <IconButton
          size="small"
          className={classes.iconButton}
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => onInsertarFila('abajo')}
        >
          <FaPlus size={9} style={{ marginRight: 2, color: '#16a34a' }} />
          <span style={{ fontSize: 10, fontWeight: 700, color: '#15803d' }}>Fila</span>
        </IconButton>
      </Tooltip>
      <Tooltip title="Eliminar fila actual">
        <IconButton
          size="small"
          className={classes.iconButton}
          onMouseDown={(e) => e.preventDefault()}
          onClick={onEliminarFila}
        >
          <FaMinus size={9} style={{ marginRight: 2, color: '#dc2626' }} />
          <span style={{ fontSize: 10, fontWeight: 700, color: '#dc2626' }}>Fila</span>
        </IconButton>
      </Tooltip>

      {/* Separador vertical */}
      <span style={{ height: 16, borderRight: '1px solid #cbd5e1', margin: '0 4px' }} />

      {/* Acciones de Columnas */}
      <Tooltip title="Insertar columna a la derecha">
        <IconButton
          size="small"
          className={classes.iconButton}
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => onInsertarColumna('derecha')}
        >
          <FaPlus size={9} style={{ marginRight: 2, color: '#16a34a' }} />
          <span style={{ fontSize: 10, fontWeight: 700, color: '#15803d' }}>Col</span>
        </IconButton>
      </Tooltip>
      <Tooltip title="Eliminar columna actual">
        <IconButton
          size="small"
          className={classes.iconButton}
          onMouseDown={(e) => e.preventDefault()}
          onClick={onEliminarColumna}
        >
          <FaMinus size={9} style={{ marginRight: 2, color: '#dc2626' }} />
          <span style={{ fontSize: 10, fontWeight: 700, color: '#dc2626' }}>Col</span>
        </IconButton>
      </Tooltip>

      {/* Separador vertical */}
      <span style={{ height: 16, borderRight: '1px solid #cbd5e1', margin: '0 4px' }} />

      {/* Eliminar tabla completa */}
      <Tooltip title="Eliminar tabla completa">
        <IconButton
          size="small"
          className={classes.iconButton}
          style={{ color: '#ef4444' }}
          onMouseDown={(e) => e.preventDefault()}
          onClick={onEliminarTabla}
        >
          <FaTrashAlt size={11} />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default React.memo(BarraContextualTabla);
